const vars = {
  GLOBAL_COMMITMENT_STRUCTURE_ID: '5kXMAmDvTfeOYZRv17P9BW',
  GLOBAL_COMMITMENT_BASE_PATH: '/global-commitment-2021',
  GLOBAL_COMMITMENT_LISTING_PAGE_SLUG: 'signatory-reports',
  GLOBAL_COMMITMENT_WHO_IS_INVOLVED_PAGE_SLUG: 'who-is-involved',
  GLOBAL_COMMITMENT_DEFAULT_META_TITLE:
    '2021 Global Commitment report on plastic packaging',
  GLOBAL_COMMITMENT_DEFAULT_META_DESCRIPTION:
    '2021 Global Commitment progress report data on plastic packaging to create a circular economy for plastics and fight plastic pollution.',
  GLOBAL_COMMITMENT_DEFAULT_MASTEHEAD_TITLE:
    'Global Commitment 2021 Signatory Report',
  GLOBAL_COMMITMENT_2021_REPORT_URL:
    'https://emf.thirdlight.com/link/n1ipti7a089d-ekf9l1/@/preview/1?o',
  GLOBAL_COMMITMENT_2021_DATA_URL:
    'https://emf.thirdlight.com/link/qcr9fde98nng-xoz7bd/@/preview/1?o',
};

module.exports = vars;
